import React from 'react';
import ReactDOM from 'react-dom';
import Dashboard from './Dashboard';
import Integrations from './Integrations';
import Subscribers from './Subscribers';

window.addEventListener('DOMContentLoaded', (event) => {
	var dashboard = document.getElementById('eei_dashboard');
	var subscriberList = document.getElementById('eei_subscribers_list');
	var integrationList = document.getElementById('eei_integration_list');

	if (dashboard) {
		ReactDOM.render(<Dashboard />, dashboard);
	}

	if (subscriberList) {
		ReactDOM.render(<Subscribers />, subscriberList);
	}

	if (integrationList) {
		ReactDOM.render(<Integrations />, integrationList);
	}
});
